import { themeStyled as styled } from '@parapet/common';

export const InputText = styled.input`
  width: 100%;
  background-color: transparent;
  padding: 12px 8px;
  font-family: inherit;
  font-size: 14px;
  border-radius: 0;
  border: 0;
  border-bottom: 1px solid var(--input-border-color);
  outline: none;
  color: var(--input-text-color);
  &::placeholder {
    color: var(--input-placeholder-color);
  }
  &:focus {
    box-shadow: none;
    outline: none;
    border-bottom-color: var(--primary-500);
    &::placeholder {
      color: var(--input-placeholder-color) !important;
    }
  }
  &:invalid.submitted {
    border-bottom-color: var(--input-error-text, red);
  }
  &:is(:-webkit-autofill, :-internal-autofill-selected, :autofill) {
    border-radius: 2px;
    font-weight: 600;
    border-color: transparent;
    box-shadow: 0 0 0 2px #8f34e8;
  }
`;
